import React from 'react';
import PropTypes from 'prop-types';
import { Col, Empty, Row } from 'antd';
import { Title } from 'components';
import { MailOutlined, PhoneOutlined, UserOutlined } from '@ant-design/icons';
import SkeletosWrappers from './SkeletosWrappers';

const { SkeletonWrapperText } = SkeletosWrappers;

const ResponsableTab = ({ plantilla, loading }) => {
  const {
    encargadoDeResolucionName,
    puestoEncargadaDeResolucion,
    emailResponsableDeResolucion,
    celularResponsableDeResolucion,
  } = plantilla || {};

  if (
    !encargadoDeResolucionName
    && !puestoEncargadaDeResolucion
    && !emailResponsableDeResolucion
    && !celularResponsableDeResolucion
  ) {
    return <Empty description="Este trámite no tiene responsable de resoluición" />;
  }

  const fields = [
    { label: 'Nombre', value: encargadoDeResolucionName, icon: <UserOutlined /> },
    { label: 'Cargo', value: puestoEncargadaDeResolucion, icon: <UserOutlined /> },
    { label: 'Correo', value: emailResponsableDeResolucion, icon: <MailOutlined /> },
    { label: 'Contacto', value: celularResponsableDeResolucion, icon: <PhoneOutlined /> },
  ];

  return (
    <>
      <Row justify="center">
        <Title $accent level={3}>
          Responsable de la resolución
        </Title>
      </Row>
      <br />
      <Row>
        {fields.map((field) => (
          <Col span={24} key={field.label}>
            <SkeletonWrapperText dataLabel={field.label} loading={loading} icon={field.icon}>
              {field.value}
            </SkeletonWrapperText>
          </Col>
        ))}
      </Row>
    </>
  );
};

ResponsableTab.propTypes = {
  plantilla: PropTypes.shape({
    encargadoDeResolucionName: PropTypes.string,
    puestoEncargadaDeResolucion: PropTypes.string,
    celularResponsableDeResolucion: PropTypes.string,
    emailResponsableDeResolucion: PropTypes.string,
    rolesDeResponsableDeResolucion: PropTypes.string,
  }),
  loading: PropTypes.bool,
};

ResponsableTab.defaultProps = {
  plantilla: {},
  loading: false,
};

export default ResponsableTab;
